import Default from "@/Controller/Default";
window.app = new Default;
